import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { useRouter } from "next/router";
import Layout from "../../components/Layout";
import PageIntro from "components/content/PageIntro/PageIntro";
import { SignIn } from "@clerk/nextjs";
import { site } from "config";

import styles from "./sign-in.module.scss";

export default function Page({ layoutData }) {
  const router = useRouter();

  const { redirect } = router.query;

  const seo = {
    metaDescription: "Sign in to your Where Next account.",
    metaTitle: "WhereNext | Sign In",
    canonicalURL: `${site}/sign-in`,
  };

  return (
    <Layout layoutData={layoutData} showEmailSignup={false} seo={seo}>
      <main className={`${styles.signIn} variable-container`}>
        <PageIntro title="Sign In" />
        <div className={`${styles.signInElement}`}>
          <SignIn
            path="/sign-in"
            routing="path"
            redirectUrl={redirect ? redirect : "/"}
          />
        </div>
      </main>
    </Layout>
  );
}

export async function getStaticProps() {
  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: {
      layoutData: layoutData,
    },
  };
}

export async function getStaticPaths(index) {
  return {
    paths: [],
    fallback: "blocking",
  };
}
